import React, { Component } from 'react'
import { observer } from 'mobx-react'
import Rowbox from '../Common/Rowbox'
import {
  DECORATION_MERCHANT_VIDEO,
  VIDEO_STATUS_PADDING,
  VIDEO_STATUS_FAIL
} from '@constant'
import { dGet } from '@core/utils'
import Main from './Main'

/**
 * 顶部配置
 */
@observer
export default class extends Component {
  getStatus = () => {
    const { allStatus } = this.props.store
    let status = ''

    const merchant_video = dGet(allStatus, 'merchant_video', {})

    if (merchant_video) {
      if (merchant_video.status == VIDEO_STATUS_FAIL) {
        status = 'rejected'
      } else if (merchant_video.status == VIDEO_STATUS_PADDING) {
        status = 'verifying'
      }
    }
    return status
  }

  render() {
    const {
      store: { videoData, liveData, mode }
    } = this.props

    const { path } = videoData
    const { video_path } = liveData
    const videoPath = mode === 'preview' ? video_path || path : path
    const status = this.getStatus()

    return mode === 'editable' || (mode === 'preview' && videoPath) ? (
      <Rowbox
        type={DECORATION_MERCHANT_VIDEO}
        store={this.props.store}
        style={{
          flexDirection: 'column',
          padding: '0 12px',
          height: 197
        }}
        status={status}
        vCenter={false}
      >
        <Main />
      </Rowbox>
    ) : null
  }
}
